import { marked, Tokenizer } from 'marked'
import { useEffect } from 'react'

export function useMarkedStartupHooks() {
  useEffect(() => {
    marked.use({
      tokenizer: {
        del(this: Tokenizer, src: string) {
          const delMatch = src.match(/(?!~\s+~)^~+([^~\n]+?)~+/)

          if (delMatch) {
            return {
              type: 'del',
              raw: delMatch[0],
              text: delMatch[1],
              tokens: this.lexer.inlineTokens(delMatch[1])
            }
          }

          return false
        },

        emStrong(this: Tokenizer, src: string) {
          const strongMatch = src.match(/(?!^\*\s)(?!\*\s+\*)^\*+([^*\n]+?)\*+/)

          if (strongMatch) {
            return {
              type: 'strong',
              raw: strongMatch[0],
              text: strongMatch[1],
              tokens: this.lexer.inlineTokens(strongMatch[1])
            }
          }

          const emMatch = src.match(/(?!_\s+_)^_+([^_\n]+?)_+/)
          if (emMatch) {
            return {
              type: 'em',
              raw: emMatch[0],
              text: emMatch[1],
              tokens: this.lexer.inlineTokens(emMatch[1])
            }
          }

          return false
        }
      }
    })
  }, [])
}
